export const getCookie = (name) => {
    // Split the cookies into individual key-value pairs
    const cookies = document.cookie?.split(';');

    for (let cookie of cookies) {
        cookie = cookie.trim();

        if (cookie.startsWith(name + '=')) {
            return cookie.substring(name.length + 1);
        }
    }

    return null;
}

export const localeDatetime = (utcStr, userLocale = null, hasTime = true, hasDate = true) => {
	const utcDateTime = new Date(utcStr);
	utcDateTime?.setSeconds(0); //remove seconds

	const dateTimeFormat = new Intl.DateTimeFormat();
	const timeZone = dateTimeFormat.resolvedOptions().timeZone;
	userLocale = userLocale || navigator.language || navigator.userLanguage;
	let options = {timeZone: timeZone};
	if (hasTime) {
		options = {...options, hour: 'numeric', minute: 'numeric', hour12: false}
	}
	if (hasDate) {
		options = {...options, year: 'numeric', month: '2-digit', day: '2-digit'}
	}

	return utcDateTime?.toLocaleString(userLocale, options)
}

export const checkEmail = (email) => {
    // /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/ 
    // /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*$/
    // /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{1,63})+$/
    const pattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[a-z0-9-]{2,63})\b/i;
      return email.match(pattern);
}


/**
 * Format a price amount based on language and currency
 *
 * @param {object} price The price object
 * @return {string} The formatted display price
 */
export const formatMoney = (price = {}, language = 'en') => {
    return price.amount?.toLocaleString(
        language,
        {
            style: 'currency',
            currency: price.currency || 'EUR'
        }
    );
}
